import {
  createContext,
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from 'react';

export type CopilotPaneContextType = {
  closeCopilotPane: () => void;
  copilotPaneIsOpen: boolean;
  openCopilotPane: () => void;
};

export const CopilotPaneContext = createContext<CopilotPaneContextType>(
  {} as CopilotPaneContextType,
);

export const CopilotPaneContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeCopilotPane = useCallback(() => {
    setIsOpen(false);
  }, []);

  const openCopilotPane = useCallback(() => {
    setIsOpen(true);
  }, []);

  return (
    <CopilotPaneContext.Provider
      value={{
        closeCopilotPane,
        copilotPaneIsOpen: isOpen,
        openCopilotPane,
      }}
    >
      {children}
    </CopilotPaneContext.Provider>
  );
};

CopilotPaneContextProvider.displayName = 'CopilotPaneContextProvider';

export function useCopilotPaneContext(): CopilotPaneContextType {
  return useContext(CopilotPaneContext);
}
